import { SagaIterator } from 'redux-saga';
import { fork, put, take } from 'redux-saga/effects';
import config from '@/server/config';
import request from '@/server/request';

// 定义常量
export const types = {
    ADDRESS_CONFIRM: 'user/php/ui/address/ADDRESS_CONFIRM',
    ADDRESS_HIDE: 'user/php/ui/address/ADDRESS_HIDE',
    ADDRESS_SELECT: 'user/php/ui/address/ADDRESS_SELECT',
    ADDRESS_SHOW: 'user/php/ui/address/ADDRESS_SHOW',
    ADDRESS_TAB: 'user/php/ui/address/ADDRESS_TAB',
    ADDRESS_RESET: 'user/php/ui/address/ADDRESS_RESET',
    GET_ADDRESS_START: 'user/php/ui/address/GET_ADDRESS_START',
    GET_ADDRESS_SUCCESS: 'user/php/ui/address/GET_ADDRESS_SUCCESS',
}

let row: number = 3;
let bindConfirmAction: any;
let bindHideAction: any;

// 定义地址action接口
export interface IAddressAction {
    type: string;
    data?: {
        pCode?: any;
        copy?: boolean;
        level?: number;
    };
    showData?: {
        init?: any;
        row?: number; // 1 省 2 市 3 区
        onConfirm?(r: any): void;
        onHide?(): void;
    }
    selectData?: {
        index: number;
        k: number;
        code: number
    };
    tabData?: {
        index: number;
    };
    payload?: any;
}
// 定义地址状态接口
export interface IAddressStoreState {
    copyListCity: any[];
    copyListDist: any[];
    listPro: any[];
    listCity: any[];
    listDist: any[];
    cityIndex: number, // 市索引
    distIndex: number, // 区索引
    proIndex: number, // 省索引
    tabIndex: number,
    visible: boolean;
}

// 定义各方法，以供组件内部调用
/**
 * [获取地址数据]
 * @param pCode 父级地区编码
 * @param level 0:省 1:市 2:区
 * @return action类型 
 */
export const getData = (pCode: any = '', level: number): IAddressAction => {
    return {
        type: types.GET_ADDRESS_START,
        data: {
            pCode,
            level
        }
    }
}
// 隐藏面板
export const hideAction = () => {
    return {
        type: types.ADDRESS_HIDE
    }
}

//  切换
export const tabAction = (index: number) => {
    return {
        tabData: {
            index
        },
        type: types.ADDRESS_TAB
    }
}

// 重制
export const resetAction = () => { 
    return {
        type: types.ADDRESS_RESET
    }
}

// 选择某一项
export const selectItem = (index: number, k: number, code: number) => {
    return {
        selectData: {
            index, k, code
        },
        type: types.ADDRESS_SELECT
    }
}

/**
 * [导出reducer] 使用export default导出，Ducks模式规则
 * @param state 组件状态
 * @param action 组件本次提供的action
 * @return 组件状态
 */
const initialState: IAddressStoreState = {
    copyListCity: [],
    copyListDist: [],
    listPro: [],
    listCity: [],
    listDist: [],
    cityIndex: -1, // 市索引
    distIndex: -1, // 区索引
    proIndex: -1, // 省索引
    tabIndex: 0,
    visible: false,
};

export default (state: IAddressStoreState = initialState, action: IAddressAction): IAddressStoreState => {
    switch(action.type) {
        case types.ADDRESS_CONFIRM:
            return {
                ...state,
                copyListCity: [...state.listCity],
                copyListDist: [...state.listDist],
                visible: false
            }
        case types.ADDRESS_SHOW:
            if (action.showData) { 
                // 绑定确认处理函数
                if (action.showData.onConfirm) {
                    bindConfirmAction = action.showData.onConfirm;
                } else {
                    bindConfirmAction = null;
                }
                // 绑定取消处理函数
                if(action.showData.onHide) {
                    bindHideAction = action.showData.onHide;
                } else {
                    bindHideAction = null;
                }
                if (action.showData.row) {
                    row = action.showData.row;
                } else { 
                    row = 3;
                }
            }
            const initData = action.showData ? action.showData.init : {};
            if (initData.province && initData.province.id) {
                let [tempProIndex, tempCityIndex, tempDistIndex] = [-1, -1, -1];
                state.listPro.map((v: any, k: number) => {
                    if(v.id === initData.province.id) {
                        tempProIndex = k;
                        if (state.listCity.length === 0 && v.children.length > 0) { 
                            state.listCity = v.children;
                        }
                    }
                });
                if (initData.city) { 
                    state.listCity.map((v: any, k: number) => {
                        if(v.id === initData.city.id) {
                            tempCityIndex = k;
                            if (state.listDist.length === 0 && v.children.length > 0) { 
                                state.listDist = v.children;
                            }
                        }
                    });
                }
                if (initData.district){ 
                    state.listDist.map((v: any, k: number) => {
                        if(v.id === initData.district.id) {
                            tempDistIndex = k;
                        }
                    });
                }
                
                return {
                    ...state,
                    cityIndex: tempCityIndex,
                    distIndex: tempDistIndex,
                    proIndex: tempProIndex,
                    tabIndex: row - 1,
                    visible: true,
                }
            } else {
                return {
                    ...state,
                    cityIndex: -1,
                    distIndex: -1,
                    proIndex: -1,
                    tabIndex: 0,
                    visible: true
                }
            }
        case types.ADDRESS_HIDE:
            if(bindHideAction) {
                bindHideAction();
            }
            return {
                ...state,
                listCity: [...state.copyListCity],
                listDist: [...state.copyListDist],
                visible: false
            }
        case types.ADDRESS_SELECT:
            if (action.selectData) {
                if (action.selectData.index === 0) {       
                    if (row === 1) { 
                        if(bindConfirmAction) {
                            bindConfirmAction({
                                city: {},
                                district: {},
                                province: state.listPro[action.selectData.k]
                            });
                        }
                    }
                    return {
                        ...state,
                        proIndex: action.selectData.k,
                        copyListCity: [...state.listCity],
                        copyListDist: [...state.listDist],
                        listCity: [],
                        listDist: [],
                        tabIndex: row === 1 ? 0 : 1,
                        visible: row === 1 ? false : true
                    }
                } else if (action.selectData.index === 1) {
                    if (row === 2) { 
                        if(bindConfirmAction) {
                            bindConfirmAction({
                                city: state.listCity[action.selectData.k],
                                district: {},
                                province: state.listPro[state.proIndex]
                            });
                        }
                    }
                    return {
                        ...state,
                        cityIndex: action.selectData.k,
                        copyListCity: [...state.listCity],
                        copyListDist: [...state.listDist],
                        listDist: [],
                        tabIndex: row === 2 ? 1 : 2,
                        visible: row === 2 ? false : true
                    }
                } else {
                    if(bindConfirmAction) {
                        bindConfirmAction({
                            city: state.listCity[state.cityIndex],
                            district: state.listDist[action.selectData.k],
                            province: state.listPro[state.proIndex]
                        });
                    }
                    return {
                        ...state,
                        distIndex: action.selectData.k,
                        copyListCity: [...state.listCity],
                        copyListDist: [...state.listDist],
                        visible: false
                    }
                }
            } else {
                return state;
            }
        case types.ADDRESS_TAB:
            if(action.tabData) {
                if(action.tabData.index === 0) {
                    return {
                        ...state,
                        proIndex: -1,
                        cityIndex: -1,
                        distIndex: -1,
                        tabIndex: action.tabData.index
                    }
                } else if(action.tabData.index === 1) {
                    return {
                        ...state,
                        cityIndex: -1,
                        distIndex: -1,
                        tabIndex: action.tabData.index
                    }
                } else {
                    return {
                        ...state,
                        distIndex: -1,
                        tabIndex: action.tabData.index
                    }
                }
            } else {
                return state;
            }
        case types.GET_ADDRESS_SUCCESS:
            const r = action.payload.data;
            if(r.error_code === 0 && r.data) {
                if(!action.payload.level || action.payload.level === 0) {
                  return {
                      ...state,
                      listPro: r.data
                  }
                } else if(action.payload.level === 1) {
                    if(action.payload.copy) {
                        return {
                            ...state,
                            copyListCity: r.data,
                            listCity: r.data
                        }
                    }
                    return {
                        ...state,
                        listCity: r.data
                    }
                } else if(action.payload.level === 2) {
                    if(action.payload.copy) {
                        return {
                            ...state,
                            copyListDist: r.data,
                            listDist: r.data
                        }
                    }
                    return {
                        ...state,
                        listDist: r.data
                    }
                }
            } else {
                return state;
            }
        case types.ADDRESS_RESET:
            return initialState;
        default:
            return state;
    }
}

// 定义saga
/**
 * 本页面使用，获取数据异步操作处理函数
 * @param action 组件提供action
 */
function* getListDataAsyncPHP(action: IAddressAction): any {
    console.log(1);
    const r = yield request({
        url: `${config.ULKAPI}api/web/index.php?r=index/regions&pCode=${action.data!.pCode}`
      });
    yield put({ type: types.GET_ADDRESS_SUCCESS, payload: {
        copy: action.data ? action.data.copy : false,
        data: r,
        level: action.data ? action.data.level : 1,
    } });
}

// 利用takeEvery检测未来可能会发生的行为，并且执行相应的操作
export function* watchPHPAddressDataAsync(): SagaIterator {
    // 写法1（可以连续接收到action）
    // yield takeEvery( types.RECEIVE_START, getListDataAsync );

    // 写法2（时间间隔过短无法连续接收到action，会有遗漏，可使用异步fork避免）
    while(true) {
        const action = yield take(types.GET_ADDRESS_START);
        yield fork(getListDataAsyncPHP, action);
    }
}

